import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=81cf319c&scoped=true&"
import script from "./AccountSettings.vue?vue&type=script&lang=ts&"
export * from "./AccountSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSettings.vue?vue&type=style&index=0&id=81cf319c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cf319c",
  null
  
)

export default component.exports